// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import MediaProvider from './MediaProvider';

export * from './MediaProvider';
export default MediaProvider;
